import { __assign, __rest } from "tslib";
import * as React from 'react';
import { getPureTime, oneDay, toTimeString } from './internal/common.js';
import { PickerPopup } from './internal/PickerPopup.js';
import { useOutsideClick } from '../../hooks/index.js';
export var TimeField = function (_a) {
    var onChange = _a.onChange, error = _a.error, label = _a.label, value = _a.value, _b = _a.minTime, minTime = _b === void 0 ? 0 : _b, _c = _a.maxTime, maxTime = _c === void 0 ? oneDay : _c, readOnly = _a.readOnly, _d = _a.defaultValue, defaultValue = _d === void 0 ? minTime : _d, children = _a.children;
    var el = React.useRef(undefined);
    var controlled = React.useMemo(function () { return value !== undefined; }, []);
    var initial = controlled ? value : defaultValue;
    var _e = React.useReducer(function (state, values) {
        var force = values.force, update = __rest(values, ["force"]);
        var newState = __assign(__assign({}, state), update);
        if (!force && newState.time !== state.time) {
            var value_1 = newState.time;
            setTimeout(function () { return onChange === null || onChange === void 0 ? void 0 : onChange(value_1); });
        }
        if (controlled && !force) {
            newState.time = state.time;
            newState.input = state.input;
        }
        return newState;
    }, {
        valid: true,
        time: getPureTime(initial),
        input: toTimeString(initial),
        showPicker: false,
    }), state = _e[0], dispatch = _e[1];
    var openPicker = React.useCallback(function () { return dispatch({ showPicker: true }); }, []);
    React.useEffect(function () {
        var input = value || defaultValue;
        var time = getPureTime(input);
        if (state.time !== time) {
            dispatch({
                valid: !!time,
                time: time,
                input: typeof input === 'string' ? input : toTimeString(input),
                force: true,
            });
        }
    }, [controlled ? value : undefined]);
    var handleClickOutsideCalendar = React.useCallback(function () {
        dispatch({ showPicker: false });
    }, []);
    useOutsideClick(el, handleClickOutsideCalendar);
    var change = React.useCallback(function (e) {
        var input = e.target.value;
        var time = getPureTime(input);
        var invalid = time === 0;
        dispatch({
            valid: !invalid,
            time: time || getPureTime(minTime),
            input: input,
        });
    }, [minTime, maxTime]);
    return (React.createElement("div", { ref: el, className: "form-group" },
        React.createElement("input", { className: "form-control".concat(!error && state.valid ? '' : ' error'), type: "text", readOnly: readOnly, placeholder: "HH:mm:ss", value: state.input, onChange: change, onFocus: openPicker }),
        label && React.createElement("label", { className: "text-floating" }, label),
        React.createElement("i", { className: "fas fa-clock date-picker-icon", onClick: openPicker }),
        children,
        !readOnly && state.showPicker && (React.createElement(PickerPopup, { value: state.time, min: getPureTime(minTime), max: getPureTime(maxTime), dispatch: dispatch }))));
};
//# sourceMappingURL=index.js.map